(function(){
  function parseNumber(text){
    var match=String(text||'').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match?Number(match[0]):NaN;
  }
  function enhanceSizeGuide(){
    var buttons=document.querySelectorAll('.courum-guide-calc button');
    for(var i=0;i<buttons.length;i++){
      var button=buttons[i];
      if(button.dataset.courumSizeEnhanced==='true'){continue;}
      button.dataset.courumSizeEnhanced='true';
      button.onclick=function(){
        var calc=this.parentNode;
        var height=Number(calc.querySelector('.courum-height').value);
        var weight=Number(calc.querySelector('.courum-weight').value);
        var result=calc.querySelector('strong');
        if(!height||!weight){
          result.innerText='Informe sua altura e peso para calcular o tamanho.';
          return;
        }
        var rows=(calc.nextElementSibling||document).querySelectorAll('tbody tr');
        var bodyScore=(0.35*height)+(0.55*weight);
        var baseIndex=-1;
        for(var r=0;r<rows.length;r++){
          var cells=rows[r].cells;
          var widthLimit=cells.length>2?parseNumber(cells[2].innerText):NaN;
          if(!isNaN(widthLimit) && baseIndex<0 && widthLimit>=bodyScore){
            baseIndex=r;
          }
        }
        if(baseIndex<0){baseIndex=Math.max(0, rows.length-1);}
        var recommendedIndex=Math.min(baseIndex+1, Math.max(0, rows.length-1));
        var recommended='';
        if(rows[recommendedIndex]&&rows[recommendedIndex].cells.length){
          recommended=String(rows[recommendedIndex].cells[0].innerText||'').trim();
        }
        result.innerText=recommended?'Tamanho recomendado: '+recommended+' (um tamanho acima para melhor caimento).':'Não foi possível calcular o tamanho agora.';
      };
    }
  }
  function run(){
    if(!/\/products\//.test(window.location.pathname)){return;}
    enhanceSizeGuide();
    var nodes=document.querySelectorAll('h1,h2,h3,h4,span,div');
    for(var i=0;i<nodes.length;i++){
      var node=nodes[i];
      if(node.children.length){continue;}
      var text=(node.textContent||'').replace(/\s+/g,' ').trim();
      if(text==='Talvez você goste'){node.textContent='NOSSAS RECOMENDAÇÕES';}
      if(text==='1ª Troca'){node.textContent='Troca';}
      if(text==='Cortesia'){node.textContent='Simplificada';}
    }
    setTimeout(enhanceSizeGuide,500);
    setTimeout(enhanceSizeGuide,1200);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run);
  }else{
    run();
  }
})();
